import get from 'lodash/get';
import { createSelector } from 'reselect';

export const programsSelector = state => state.programs;
export const joinedProgramsSelector = state => state.programs.joinedPrograms;
export const availableProgramsSelector = state =>
  state.programs.availablePrograms;

export const joinedProgramsListSelector = createSelector(
  joinedProgramsSelector,
  programs => get(programs, 'list', []),
);

export const joinedProgramsMetaSelector = createSelector(
  joinedProgramsSelector,
  programs => get(programs, 'meta', {}),
);

export const joinedProgramsSendingSelector = createSelector(
  joinedProgramsSelector,
  programs => get(programs, 'sending'),
);

export const availableProgramsListSelector = createSelector(
  availableProgramsSelector,
  programs => get(programs, 'list'),
);

export const selectPaymentInfoModalState = createSelector(
  programsSelector,
  state => get(state, 'paymentInfoModal'),
);

export const selectPaymentInfoModalOpen = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'opened', false),
);

export const selectPaymentInfoModalSubscriptionsSetting = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'subscriptionsSetting', {}),
);

export const selectPaymentInfoModalProgramId = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'programId', null),
);

export const selectPaymentInfoModalOrganizationId = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'organizationId', null),
);

export const selectPaymentInfoModalProgramName = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'programName', ''),
);

export const selectPaymentInfoModalDuePaymentDate = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'duePaymentDate', ''),
);

export const selectPaymentInfoModalWaitingPayaResponse = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'waitingPayaPaymentResponse', false),
);

export const selectPaymentInfoModalInvitationId = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'invitationId', null),
);

export const selectPaymentInfoModalPurchaseAgain = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'purchaseAgain', false),
);

export const selectPaymentInfoModalPrepayFlow = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'prepayFlow', false),
);

export const selectPaymentInfoModalToDoId = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'todoId', null),
);

export const selectPaymentInfoModalUserId = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'userId', null),
);

export const selectPaymentInfoModalMainUserId = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'mainUserId', null),
);

export const selectPaymentInfoModalFormLoading = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'payaFormLoading', false),
);

export const selectPaymentInfoModalPayaFormURL = createSelector(
  selectPaymentInfoModalState,
  state => get(state, 'payaFormUrl', ''),
);

export const selectAccountVaultsState = createSelector(
  programsSelector,
  state => get(state, 'accountVaults'),
);

export const selectAccountVaultsList = createSelector(
  selectAccountVaultsState,
  state => get(state, 'list', []),
);

export const selectAccountVaultsListLoading = createSelector(
  selectAccountVaultsState,
  state => get(state, 'sending', false),
);



// WEBPACK FOOTER //
// ./src/redux/programs/selectors.js